import * as CheckoutAPIActions from '../../APIActions/CheckoutAPIActions';
import {OrderSummaryUpdateReasons, setOrderSummaryUpdating, updateOrderSummary} from '../../orderSummaryActions';

export function removeAllCreditsAndGetOrderSummary() {
  return (dispatch) => {
    dispatch(setOrderSummaryUpdating(OrderSummaryUpdateReasons.UPDATED_APPLIED_CREDIT));
    return dispatch(CheckoutAPIActions.removeCredit())
      .then((orderSummary) => {
        dispatch(updateOrderSummary(orderSummary.msg));
      });
  };
}

export function applyCreditAndGetOrderSummary(amount) {
  return (dispatch) => {
    dispatch(setOrderSummaryUpdating(OrderSummaryUpdateReasons.UPDATED_APPLIED_CREDIT));
    
    const requestPayload = {amount};
    return dispatch(CheckoutAPIActions.applyCredit(requestPayload))
      .then((orderSummary) => {
        dispatch(updateOrderSummary(orderSummary.msg));
      });
  };
}
